import styled from 'styled-components';

/* Desktop/Heading/Medium */
const mediumHeadingStyles = `
  color: #fff;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 38.4px */
`;
// Bold headings styles from Figma /* Heading/Bold */
const boldHeadingStyles = `
  font-weight: 700;
  line-height: 120%;
  color: #fff;
   position: relative;
  z-index: 1;
  `;

// Regular headings styles from Figma /* Heading/Regular */
const regularHeadingStyles = `
  font-weight: 400;
  line-height: 120%;
  color: #fff;
   position: relative;
  z-index: 1;
  `;

// Regular body text styles from Figma /* Body Text/Regular */
const regularBodyTextStyles = `
  font-weight: 400;
  line-height: 140%;
  color: #fff;
   position: relative;
  z-index: 1;
  `;

// Bold body text styles from Figma /* Body Text/Bold */
const boldBodyTextStyles = `
  font-weight: 500;
  line-height: 130%;
  color: #fff;
  position: relative;
  font-style:normal;
  z-index: 1;
  `;

// Regular link styles from Figma /* Link/Regular */
const regularLinkStyles = `
  font-weight: 400;
  line-height: 140%;
  color: #fff;
  text-decoration-line: underline;
   position: relative;
  z-index: 1;
  `;

// Bold link styles from Figma /* Link/Bold */
const boldLinkStyles = `
  font-weight: 700;
  line-height: 140%;
  color: #fff;
  text-decoration-line: underline;
  position: relative;
  z-index: 1;
 
  `;

export const MediumHeadingQuinary = styled.div`
  ${mediumHeadingStyles}
  font-size: 28px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const BoldHeadingPrimary = styled.div`
  ${boldHeadingStyles}
  font-size: 40px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }
`;

export const BoldHeadingSecondary = styled.div`
  ${boldHeadingStyles}
  font-size: 32px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    margin-left: 16px;
  }
`;
export const BoldHeadingSecondary_H1 = styled.h1`
  ${boldHeadingStyles}
  font-size: 32px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    margin-left: 16px;
  }
`;

export const BoldHeadingTertiary = styled.div`
  ${boldHeadingStyles}
  font-size: 28px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }
`;

export const BoldHeadingQuaternary_H1 = styled.h1`
  ${boldHeadingStyles}
  font-size: 24px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }
`;

export const BoldHeadingQuaternary = styled.div`
  ${boldHeadingStyles}
  font-size: 24px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }
`;

export const BoldHeadingQuinary = styled.div`
  ${boldHeadingStyles}
  font-size: 20px;
  color: ${(props) => props.color || '#fff'};
  display: ${(props) => (props.display ? `${props.display}` : 'block')};

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const BoldHeadingSenary = styled.div`
  ${boldHeadingStyles}
  font-size: 16px;
  color: ${(props) => props.color || '#fff'};
`;

export const HeadingRegularPrimary = styled.div`
  ${regularHeadingStyles}
  font-size: 40px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 24px */
  }
`;

export const HeadingRegularSecondary = styled.div`
  ${regularHeadingStyles}
  font-size: 32px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 24px */
  }
`;

export const HeadingRegularTertiary = styled.div`
  ${regularHeadingStyles}
  font-size: 28px;
  color: ${(props) => props.color || '#fff'};
  @media (max-width: 768px) {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 24px */
  }
`;

export const HeadingRegularQuaternary = styled.div`
  ${regularHeadingStyles}
  font-size: 24px;
  font-weight: 500;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 24px */
  }
`;

export const HeadingRegularQuinary = styled.div`
  ${regularHeadingStyles}
  font-size: 20px;
  font-weight: 500;
  color: ${(props) => props.color || '#fff'};
`;

export const HeadingRegularSenary = styled.div`
  ${regularHeadingStyles}
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => props.color || '#fff'};
`;

export const BodyTextRegularPrimary = styled.div`
  ${regularBodyTextStyles}
  font-size: 16px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const BodyTextRegularSecondary = styled.div`
  ${regularBodyTextStyles}
  font-size: 14px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }
`;

export const BodyTextRegularTertiary = styled.div`
  ${regularBodyTextStyles}
  font-size: 12px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const BodyTextRegularQuaternary = styled.div`
  ${regularBodyTextStyles}
  font-size: 10px;
  color: ${(props) => props.color || '#fff'};
`;

export const BodyTextRegularQuinary = styled.div`
  ${regularBodyTextStyles}
  font-size: 8px;
  color: ${(props) => props.color || '#fff'};
`;

export const BodyTextBoldPrimary = styled.div`
  ${boldBodyTextStyles}
  font-size: 18px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const BodyTextBoldSecondary = styled.div`
  ${boldBodyTextStyles}
  font-size: 14px;
  color: ${(props) => props.color || '#fff'};
`;

export const BodyTextBoldTertiary = styled.div`
  ${boldBodyTextStyles}
  font-size: 12px;
  color: ${(props) => props.color || '#fff'};
`;

export const BodyTextBoldQuaternary = styled.div`
  ${boldBodyTextStyles}
  font-size: 10px;
  color: ${(props) => props.color || '#fff'};
`;

export const BodyTextBoldQuinary = styled.div`
  ${boldBodyTextStyles}
  font-size: 8px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkRegularPrimary = styled.a`
  ${regularLinkStyles}
  font-size: 16px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkRegularSecondary = styled.a`
  ${regularLinkStyles}
  font-size: 14px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkRegularTertiary = styled.a`
  ${regularLinkStyles}
  font-size: 12px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkRegularQuaternary = styled.a`
  ${regularLinkStyles}
  font-size: 10px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkRegularQuinary = styled.a`
  ${regularLinkStyles}
  font-size: 8px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkBoldPrimary = styled.a`
  ${boldLinkStyles}
  font-size: 16px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkBoldSecondary = styled.a`
  ${boldLinkStyles}
  font-size: 14px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkBoldTertiary = styled.a`
  ${boldLinkStyles}
  font-size: 12px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkBoldQuaternary = styled.a`
  ${boldLinkStyles}
  font-size: 10px;
  color: ${(props) => props.color || '#fff'};
`;

export const LinkBoldQuinary = styled.a`
  ${boldLinkStyles}
  font-size: 8px;
  color: ${(props) => props.color || '#fff'};
`;
